// Wybrany formularz: przypomnienie hasła użytkownika.
export const FORMS__REMIND_PASSWORD = 'REMIND_PASSWORD';
// Wybrany formularz: logowanie użytkownika.
export const FORMS__SIGN_IN = 'SIGN_IN';
// Wybrany formularz: rejestrowanie użytkownika.
export const FORMS__SIGN_UP = 'SIGN_UP';
// Wybrany formularz: logowanie ze zmianą hasła.
export const FORMS__SIGN_IN_WITH_PASSWORD_CHANGE = 'SIGN_IN_WITH_PASSWORD_CHANGE';
